import { render, staticRenderFns } from "./skipNoviceBoot.vue?vue&type=template&id=260730b8&scoped=true&"
import script from "./skipNoviceBoot.vue?vue&type=script&lang=js&"
export * from "./skipNoviceBoot.vue?vue&type=script&lang=js&"
import style0 from "./skipNoviceBoot.vue?vue&type=style&index=0&id=260730b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260730b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260730b8')) {
      api.createRecord('260730b8', component.options)
    } else {
      api.reload('260730b8', component.options)
    }
    module.hot.accept("./skipNoviceBoot.vue?vue&type=template&id=260730b8&scoped=true&", function () {
      api.rerender('260730b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/skipNoviceBoot/skipNoviceBoot.vue"
export default component.exports